export enum InvoicePaymentFieldName {
  EMAIL = "email",
  CONFIRM_EMAIL = "confirmEmail"
}
